import ModelTypeConstants from 'constants/ModelTypeConstants';
import {BenchlingApp, Routine, User} from 'constants/UserConstants';
import {Organization, Team} from 'orgs/OrganizationConstants';

export const PARTY_TYPES = [
  ModelTypeConstants.BENCHLING_APP,
  ModelTypeConstants.ENTITY,
  ModelTypeConstants.ROUTINE,
  ModelTypeConstants.TEAM,
] as const;

export const ALL_LEAF_PARTY_TYPES = [
  ModelTypeConstants.BENCHLING_APP,
  ModelTypeConstants.ORGANIZATION,
  ModelTypeConstants.ROUTINE,
  ModelTypeConstants.SERVICE_ACCOUNT,
  ModelTypeConstants.TEAM,
  ModelTypeConstants.USER,
] as const;

export type PartyType = (typeof ALL_LEAF_PARTY_TYPES)[number];
export type PrincipalType =
  | ModelTypeConstants.BENCHLING_APP
  | ModelTypeConstants.ROUTINE
  | ModelTypeConstants.USER;

export type Group = Organization | Team;

export type Principal = User | BenchlingApp | Routine;

export type Party = Principal | Group;

export interface PartySummary {
  id: string;
  name: string;
  handle: string;
  avatar_url?: string;
  type: PartyType;
}

export type PartyTypename =
  | 'OrganizationNode'
  | 'TeamNode'
  | 'BenchlingAppNode'
  | 'RoutinePrincipalNode'
  | 'ServiceAccountActorNode'
  | 'UserNode';

export type PrincipalTypename = 'BenchlingAppNode' | 'RoutinePrincipalNode' | 'UserNode';

export const PRINCIPAL_TYPE_TO_GRAPHQL_TYPENAME: Record<PrincipalType, PrincipalTypename> = {
  [ModelTypeConstants.BENCHLING_APP]: 'BenchlingAppNode',
  [ModelTypeConstants.ROUTINE]: 'RoutinePrincipalNode',
  [ModelTypeConstants.USER]: 'UserNode',
};

export const PRINCIPAL_GRAPHQL_TYPENAME_TO_PARTY_TYPE: Record<PrincipalTypename, PrincipalType> = {
  BenchlingAppNode: ModelTypeConstants.BENCHLING_APP,
  RoutinePrincipalNode: ModelTypeConstants.ROUTINE,
  UserNode: ModelTypeConstants.USER,
};

export function isPrincipalType(type: PartyType | undefined): type is PrincipalType {
  return (
    type === ModelTypeConstants.BENCHLING_APP ||
    type === ModelTypeConstants.ROUTINE ||
    type === ModelTypeConstants.USER
  );
}

export function isPrincipalTypename(typename: PartyTypename): typename is PrincipalTypename {
  return typename in PRINCIPAL_GRAPHQL_TYPENAME_TO_PARTY_TYPE;
}

export const PARTY_TYPE_TO_GRAPHQL_TYPENAME: Record<PartyType, PartyTypename> = {
  [ModelTypeConstants.BENCHLING_APP]: 'BenchlingAppNode',
  [ModelTypeConstants.ORGANIZATION]: 'OrganizationNode',
  [ModelTypeConstants.ROUTINE]: 'RoutinePrincipalNode',
  [ModelTypeConstants.SERVICE_ACCOUNT]: 'ServiceAccountActorNode',
  [ModelTypeConstants.TEAM]: 'TeamNode',
  [ModelTypeConstants.USER]: 'UserNode',
};

export const PARTY_GRAPHQL_TYPENAME_TO_PARTY_TYPE: Record<PartyTypename, PartyType> = {
  BenchlingAppNode: ModelTypeConstants.BENCHLING_APP,
  OrganizationNode: ModelTypeConstants.ORGANIZATION,
  RoutinePrincipalNode: ModelTypeConstants.ROUTINE,
  ServiceAccountActorNode: ModelTypeConstants.SERVICE_ACCOUNT,
  TeamNode: ModelTypeConstants.TEAM,
  UserNode: ModelTypeConstants.USER,
};

export type Author = Principal;

export type Creator = Principal;
